var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1481,
    height: 716,
    viewBox: "0 0 1481 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_342_75",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1481,
    height: 716
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1481,
    height: 716,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_342_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.586 136.009C583.351 72.9354 588.7 41.2615 751.334 74.1898C913.968 107.119 1020.78 7.25881 1181.36 1.39773C1341.94 -4.46325 1464.27 24.2698 1539.05 48.8851L1508.14 463.003L-62.4903 345.771L-44.637 106.578C-44.637 106.578 161.442 199.199 372.586 136.009Z",
    fill: "url(#paint0_linear_342_75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.177 149.023C570.74 92.304 577.038 60.8049 738.61 98.6C900.182 136.396 1009.94 39.7866 1170.63 38.7481C1331.31 37.7096 1452.73 70.1017 1526.73 96.9504L1483.4 509.953L-82.9998 345.632L-57.975 107.082C-57.975 107.082 145.231 205.847 358.177 149.023Z",
    fill: "#560170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22.1882,
    y: 192,
    width: 1503,
    height: 524,
    fill: "#560170"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_342_75",
    x1: 931.812,
    y1: 55,
    x2: 543.644,
    y2: 405.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CE02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584158,
    stopColor: "#FB4849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF234C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/FooterBg.740e895048fa80251d76a2b73cb070fc.svg";
export { ForwardRef as ReactComponent };